<template>
  <div class="grid">
    <div class="col-12">
      <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
    </div>

    <div class="col-12 p-fluid mb-4 create-invoice-po">
      <Toast />
      <ProgressModal :progress="progress">
        <template #message>
          Saving invoice in progress. Please wait...
        </template>
      </ProgressModal>

      <div class="content-wrapper">
        <div class="content-header">Create Invoice Proxy</div>
        <div class="content-body">
          <div class="grid">
            <div class="md:col-6 lg:col-6 xs:col-12 sm:col-12 grid p-0 pb-0 mb-6 mr-1">
              <div class="col-12 p-0 pb-0 mb-5 border-bottom-1 border-gray-200">
                <div class="col-12 mb-2">
                  <span class="p-float-label">
                    <CompaniesDropdown :class="{ 'p-invalid': v$.company.$error }" v-model="company"
                      @item-select="getCompanySelect($event)" :key="companyReload" forceSelection />
                  </span>
                  <div v-if="v$.company.$error" class="mt-1">
                    <small class="p-error" style="font-size: 12px">
                      {{ v$.company.$errors[0].$message }}
                    </small>
                  </div>
                </div>

                <div class="col-12">
                  <span class="p-float-label">
                    <SupplierPICDropdown :class="{ 'p-invalid': v$.supplier.$error }" v-model="supplier"
                      :company="company ? company : null" :userId="userId" :key="supplierReload"
                      @item-select="getSupplier($event)" forceSelection />
                  </span>
                  <div v-if="v$.supplier.$error" class="mt-1">
                    <small class="p-error" style="font-size: 12px">
                      {{ v$.supplier.$errors[0].$message }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="col-12 mb-2">
                <span class="p-float-label">
                  <InputText :class="{ 'p-invalid': v$.invoiceNo.$error || errorExisting }" id="invoiceNo"
                    v-model="invoiceNo" />
                  <label for="invoiceNo">Invoice Number</label>
                </span>
                <div v-if="v$.invoiceNo.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.invoiceNo.$errors[0].$message }}
                  </small>
                </div>
              </div>

              <div class="mb-2 sm:col-12 md:col-12 lg:col-6">
                <span class="p-float-label">
                  <Calendar :class="{ 'p-invalid': v$.invoiceDate.$error }" id="invoiceDate" v-model="invoiceDate"
                    dateFormat="d-M-yy" :showIcon="true" />
                  <label for="invoiceDate">Invoice Date</label>
                </span>
                <div v-if="v$.invoiceDate.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.invoiceDate.$errors[0].$message }}
                  </small>
                </div>
              </div>

              <div class="mb-2 sm:col-12 md:col-12 lg:col-6">
                <span class="p-float-label">
                  <Calendar id="glDate" v-model="glDate" dateFormat="d-M-yy" :showIcon="true" />
                  <label for="glDate">GL Date</label>
                </span>
                <div v-if="v$.glDate.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.glDate.$errors[0].$message.replace("Value", "GL Date") }}
                  </small>
                </div>
              </div>

              <div class="col-12 mb-2">
                <span class="p-float-label">
                  <Textarea id="description" rows="5" v-model="description" :maxlength="230" />
                  <label for="description">Description</label>
                </span>
                <div v-if="v$.description.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.description.$errors[0].$message }}
                  </small>
                </div>
              </div>

              <div class="mb-2 sm:col-12 md:col-12 lg:col-6">
                <span class="p-float-label">
                  <InputText :class="{ 'p-invalid': v$.taxInvoiceNo.$error }" id="taxInvoiceNo" v-model="taxInvoiceNo"
                    @change="handleChangeTax($event)" />
                  <label for="taxInvoiceNo">Tax Invoice No</label>
                </span>
                <div v-if="v$.taxInvoiceNo.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.taxInvoiceNo.$errors[0].$message }}
                  </small>
                </div>
              </div>

              <div class="mb-2 sm:col-12 md:col-12 lg:col-6">
                <span class="p-float-label">
                  <Calendar :class="{ 'p-invalid': v$.taxInvoiceDate.$error }" id="taxInvoiceDate"
                    v-model="taxInvoiceDate" dateFormat="d-M-yy" :showIcon="true" />
                  <label for="taxInvoiceDate">Tax Invoice Date</label>
                </span>
                <div v-if="v$.taxInvoiceDate.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.taxInvoiceDate.$errors[0].$message }}
                  </small>
                </div>
              </div>

              <div class="col-12 mb-2">
                <span class="p-float-label mb-3">
                  <label for="FileUpload">Attachment</label>
                </span>
                <FileUpload :class="{ 'p-invalid': v$.file.$error }" class="w-full" ref="fileUpload" mode="advanced"
                  chooseLabel="Upload Tax Attachment" fileLimit="1" accept="application/pdf" :maxFileSize="5000000"
                  :showUploadButton="false" :showCancelButton="false" :customUpload="true" @select="onSelectFile"
                  @remove="onRemoveFile" />
                <div v-if="v$.file.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.file.$errors[0].$message }}
                  </small>
                </div>
              </div>
            </div>

            <div class="md:col-6 lg:col-6 xs:col-12 sm:col-12 grid p-0 pb-0 mb-6 ml-1">
              <div class="grid col-12">
                <div class="col-6 col-auto ml-auto">
                  <p>Status</p>
                </div>
                <div class="col-6 col-auto ml-auto">
                  <p style="text-align: end">{{ invoiceStatus }}</p>
                </div>
              </div>
              <div class="grid col-12">
                <div class="col-6">
                  <p>Invoice Amount</p>
                </div>
                <div class="col-6">
                  <p style="text-align: end">
                    {{
                      new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(summary.totalLine)
                    }}
                  </p>
                </div>
              </div>
              <div class="grid col-12">
                <div class="col-6">
                  <p>Tax Amount</p>
                </div>
                <div class="col-6">
                  <p style="text-align: end">
                    {{
                      new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(summary.totalPpn)
                    }}
                  </p>
                </div>
              </div>
              <div class="grid col-12">
                <div class="col-6">
                  <p>Total</p>
                </div>
                <div class="col-6">
                  <p style="text-align: end">
                    {{
                      new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(summary.totalInvoice)
                    }}
                  </p>
                </div>
              </div>

              <div class="col-12">
                <span class="p-float-label">
                  <CurrenciesDropdown :class="{ 'p-invalid': v$.currency.$error }" id="currency" v-model="currency"
                    :company="company" :key="curReload" />
                  <label for="currency">Select Currency</label>
                </span>
                <div v-if="v$.currency.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.currency.$errors[0].$message }}
                  </small>
                </div>
              </div>

              <div class="grid col-12">
                <div class="col-6">
                  <span class="p-float-label">
                    <RemitToBankDropdown :class="{ 'p-invalid': v$.billBank.$error }" id="remitBank" v-model="billBank"
                      :company="company" :supplier="supplier ? supplier : null"
                      :vendor_site_id="vendorSiteId ? vendorSiteId : null" :key="remitReload" />
                    <label for="remitBank">Remit to Bank</label>
                  </span>
                  <div v-if="v$.billBank.$error" class="mt-1">
                    <small class="p-error" style="font-size: 12px">
                      {{ v$.billBank.$errors[0].$message }}
                    </small>
                  </div>
                </div>
                <div class="col-6">
                  <span class="p-float-label">
                    <PaymentMethodsDropdown :class="{ 'p-invalid': v$.paymentMethod.$error }" id="paymentMethod"
                      v-model="paymentMethod" :company="company ? company : null" :supplier="supplier ? supplier : null"
                      :vendor_id="vendorId ? vendorId : null" :key="payReload" />
                    <label for="paymentMethod">Payment Method</label>
                  </span>
                  <div v-if="v$.paymentMethod.$error" class="mt-1">
                    <small class="p-error" style="font-size: 12px">
                      {{ v$.paymentMethod.$errors[0].$message }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="grid col-12 mb-2">
                <div class="col-6">
                  <span class="p-float-label">
                    <TermsDropdown :class="{ 'p-invalid': v$.term.$error }" id="term" v-model="term" :company="company"
                      :supplier="supplier ? supplier : null" :key="termReload" />
                    <label for="term">Select a Term</label>
                  </span>
                  <div v-if="v$.term.$error" class="mt-1">
                    <small class="p-error" style="font-size: 12px">
                      {{ v$.term.$errors[0].$message }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="col-9 mb-2">
                <span class="p-float-label">
                  <InputText id="refNum" v-model="blNumber" :disabled="true" />
                  <label for="refNum">B/L Number</label>
                </span>
                <div v-if="v$.blNumber.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.blNumber.$errors[0].$message }}
                  </small>
                </div>
              </div>
              <div class="col-3 mb-2">
                <Button :disabled="!vendorId" label="Find B/L" class="p-button-success"
                  @click="displayBLModal = true" />
              </div>

              <div class="col-12 mb-2">
                <span class="p-float-label">
                  <CostCenterDropdown :class="{ 'p-invalid': v$.costCenter.$error }" id="costCenter"
                    v-model="costCenter" :company="company" :key="ccReload" @item-select="getCostCenter($event)" />
                  <label for="costCenter">Cost Center</label>
                </span>
                <div v-if="v$.costCenter.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.costCenter.$errors[0].$message }}
                  </small>
                </div>
              </div>

              <div v-if="userId == 50103" class="col-12 mb-2">
                <span class="p-float-label">
                  <CCOwnerDropdown :class="{ 'p-invalid': v$.costCenter.$error }" id="costCenterOwner" v-model="ccOwner"
                    :company="costCenter" :key="ccOwnerReload" />
                  <label for="costCenterOwner">Select CC Owner</label>
                </span>
                <div v-if="v$.ccOwner.$error" class="mt-1">
                  <small class="p-error" style="font-size: 12px">
                    {{ v$.ccOwner.$errors[0].$message }}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 grid p-0 pb-0">
            <div class="col-12 mb-2">
              <span class="p-float-label">
                <InputText id="dummy" hidden="true" />
                <label for="dummy">Line</label>
              </span>
            </div>

            <div class="col-12 mb-2">
              <DataTable :value="selectedLines" :scrollable="true" scrollDirection="both" scrollHeight="600px"
                responsiveLayout="scroll">
                <Column header="Category" style="width: 20%">
                  <template #body="{ data, index }">
                    <InputText type="text" style="color: #000 !important" v-model="data.category"
                      :disabled="data.isIncluded === false" :class="{
                        'p-invalid':
                          v$.selectedLines.$error &&
                          v$.selectedLines.$errors[0].$response.$data[index].category.$error,
                      }" />
                    <div v-if="
                      v$.selectedLines.$error &&
                      v$.selectedLines.$errors[0].$response.$data[index].category.$error
                    " class="mt-1">
                      <small class="p-error" style="font-size: 12px">
                        {{
                          v$.selectedLines.$errors[0].$response.$errors[index].category[0].$message
                        }}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column header="SI Number" style="width: 20%">
                  <template #body="{ data }">
                    <InputText :modelValue="data.siNumber" :disabled="data.isIncluded === false"
                      style="color: #000 !important" />
                  </template>
                </Column>
                <Column header="Description" style="width: 20%">
                  <template #body="{ data, index }">
                    <InputText type="text" style="color: #000 !important" v-model="data.description"
                      :disabled="data.isIncluded === false" :class="{
                        'p-invalid':
                          v$.selectedLines.$error &&
                          v$.selectedLines.$errors[0].$response.$data[index].description.$error,
                      }" />
                    <div v-if="
                      v$.selectedLines.$error &&
                      v$.selectedLines.$errors[0].$response.$data[index].description.$error
                    " class="mt-1">
                      <small class="p-error" style="font-size: 12px">
                        {{
                          v$.selectedLines.$errors[0].$response.$errors[index].description[0].$message
                        }}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column header="Amount" style="width: 20%">
                  <template #body="{ data }">
                    <InputNumber v-model="data.amount" :min="0" mode="decimal" locale="de-DE" :minFractionDigits="2"
                      :maxFractionDigits="2" :disabled="data.isIncluded === false" />
                  </template>
                </Column>
                <Column header="VAT" style="width: 20%">
                  <template #body="slotProps">
                    <Dropdown :editable="true" v-model="slotProps.data.vat_code"
                      @change="onChangeVAT($event, slotProps.index)" :options="getVAT" optionLabel="vat_code"
                      optionValue="tax_rate_id" style="width: 100%" placeholder="- No Select -" forceSelection
                      :disabled="slotProps.data.isIncluded === false" />
                  </template>
                </Column>
                <Column header="WHT" style="width: 20%">
                  <template #body="slotProps">
                    <Dropdown :editable="true" v-model="slotProps.data.wht_code"
                      @change="onChangeWHT($event, slotProps.index)" :options="getWHT" optionLabel="wht_code"
                      optionValue="wht_code_id" style="width: 100%" placeholder="- No Select -" forceSelection
                      :disabled="slotProps.data.isIncluded === false" />
                  </template>
                </Column>
                <Column header="COA" style="width: 20%">
                  <template #body="{ data, index }">
                    <AutoComplete v-model="data.account" :suggestions="filteredCoa" @complete="searchAccount($event)"
                      :dropdown="true" field="account" placeholder="Account" style="width: 100%"
                      @item-select="onChangeCOALine($event, index)" forceSelection :disabled="data.isIncluded === false"
                      :class="{ 'p-invalid': !data.coa_id && data.isIncluded !== false }" />
                  </template>
                </Column>
                <Column header="Action" style="width: 10%" alignFrozen="right" frozen>
                  <template #body="{ data, index }">
                    <Button v-if="data.ACTIVE_FLAG === 'Y'"
                      :icon="data.isIncluded === false ? 'pi pi-plus' : 'pi pi-trash'"
                      class="p-button-rounded p-button-text"
                      :severity="data.isIncluded === false ? 'success' : 'danger'" @click="toggleLineActive(index)" />
                    <Button v-else icon="pi pi-lock" class="p-button-rounded p-button-text" severity="secondary"
                      disabled />
                  </template>
                </Column>
                <template #empty>
                  <div>No item.</div>
                </template>
              </DataTable>
            </div>
          </div>

          <div class="grid col-12 p-0 pb-0">
            <div class="lg:col-3 sm:col-12 md:col-12">
              <Button label="Save" class="p-button-success" @click="save()" :disabled="disabledButton" />
            </div>
            <div class="lg:col-3 sm:col-12 md:col-12">
              <Button label="Cancel" class="p-button-secondary" @click="cancel()" />
            </div>
          </div>

          <Dialog header="Select B/L" :draggable="false" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
            :style="{ width: '25vw', overflow: 'hidden' }" :modal="true" :dismissableMask="true"
            v-model:visible="displayBLModal">
            <div class="pt-4">
              <FindBLModal :dbInstance="company.db_instance" :vendorId="supplier.vendor_id"
                @on-close="displayBLModal = false" @on-save="handleSelectBL" />
            </div>
          </Dialog>
          <SimilarInvoiceConfirmationDialog
            :visible="similarInvoiceDialog"
            :similarInvoices="similarInvoices"
            @confirm="confirmSimilarInvoiceDialog"
            @cancel="cancelSimilarInvoiceDialog"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, requiredIf } from "@vuelidate/validators";
import SimpleCrypto from "simple-crypto-js";
import { useToast } from "primevue/usetoast";

import AuthService from "@/service/AuthService";
import LovService from "@/service/LovService";
import { filterAuthByVendorname } from "@/helper/filterAuthByVendorname";
import CompaniesDropdown from "../components/CompaniesDropdown.vue";
import SupplierPICDropdown from "@/components/invoicepoproxy/components/SupplierPICDropdown.vue";
import RemitToBankDropdown from "@/components/invoicepoproxy/components/RemitToBankDropdown";
import PaymentMethodsDropdown from "@/components/invoicepoproxy/components/PaymentMethodsDropdown";
import TermsDropdown from "@/components/components/TermsDropdown";
import CurrenciesDropdown from "@/components/components/CurrenciesDropdown";
import CostCenterDropdown from "@/components/invoicepoproxy/components/CostCenterDropdown";
import CCOwnerDropdown from "@/components/invoicepoproxy/components/CCOwnerDropdown.vue";
import ProgressModal from "@/components/components/ProgressModal.vue";
import FindBLModal from "./FindBLModal.vue";
import SimilarInvoiceConfirmationDialog from "@/components/invoicepoproxy/components/SimilarInvoiceConfirmationDialog.vue";

import {
  getVATList,
  getWHTList,
  saveInvoice,
  checkSimilarInvoice,
  getListCoa,
} from "@/service/InvoiceProxyNonPOServices";
import { getBLTransactionDetails } from "@/service/InvoiceProxyExportServices";

const route = useRoute();
const router = useRouter();
const toast = useToast();

const company = ref();
const companyReload = ref(0);
const supplier = ref(null);
const supplierReload = ref(0);
const invoiceNo = ref();
const invoiceDate = ref();
const glDate = ref();
const description = ref();
const taxInvoiceNo = ref();
const taxInvoiceDate = ref();
const fileUpload = ref();
const file = ref();
const errorExisting = ref(false);
const invoiceStatus = ref("OPEN");
const currency = ref();
const billBank = ref();
const paymentMethod = ref();
const term = ref();
const costCenter = ref();
const ccOwner = ref();
const curReload = ref(0);
const remitReload = ref(0);
const payReload = ref(0);
const termReload = ref(0);
const ccReload = ref(0);
const ccOwnerReload = ref(0);
const displayBLModal = ref(false);
const blNumber = ref();
const selectedLines = ref([]);
const vendorId = ref();
const vendorSiteId = ref();
const getCOA = ref([]);
const filteredCoa = ref([]);
const getVAT = ref([]);
const getWHT = ref([]);
const userInfo = ref();
const userId = ref();
const progress = ref(false);
const disabledButton = ref(false);
const similarInvoiceDialog = ref(false);
const similarInvoices = ref([]);
const similarInvoiceResolver = ref(null);

const breadcrumbHome = { icon: "pi pi-home", to: "/dashboard" };
const breadcrumbItems = [
  {
    label: "Create Invoice Proxy",
    to: route.fullPath,
  },
];

const cannotZero = (value) => Number(value) > 0;

const validationRules = computed(() => ({
  company: { required },
  supplier: { required },
  invoiceNo: { required },
  invoiceDate: { required },
  glDate: { required },
  description: { required },
  taxInvoiceNo: { required },
  taxInvoiceDate: { required },
  currency: { required },
  billBank: { required },
  paymentMethod: { required },
  term: { required },
  costCenter: { required },
  file: { required },
  blNumber: { required },
  ccOwner: { required: requiredIf(sessionStorage.getItem("idUser") == 50103) },
  selectedLines: {
    $each: helpers.forEach({
      category: { required },
      description: { required },
      amount: {
        required,
        cannotZero: helpers.withMessage(
          "The amount value must be greater than zero",
          cannotZero
        ),
      },
    }),
  },
}));

const v$ = useVuelidate(validationRules, {
  company,
  supplier,
  invoiceNo,
  invoiceDate,
  glDate,
  description,
  taxInvoiceNo,
  taxInvoiceDate,
  currency,
  billBank,
  paymentMethod,
  term,
  costCenter,
  file,
  blNumber,
  ccOwner,
  selectedLines,
});

watch(() => company.value, () => {
  supplier.value = null;
  supplierReload.value++;
  curReload.value++;
  ccReload.value++;
  resetSelectedBL();
});

watch(() => vendorId.value, async () => {
  payReload.value++;
  termReload.value++;
  remitReload.value++;
});

watch(() => vendorSiteId.value, () => {
  remitReload.value++;
});

watch(() => invoiceDate.value, async () => {
  await getDropdownVat();
  await getDropdownWHT();
});

watch(() => costCenter.value, async () => {
  if (costCenter.value) {
    await getDropdownCOA();
  }
});

AuthService.whoAmi().then(async (response) => {
  if (response.status === 200) {
    userInfo.value = response.data.data;
    userId.value = response.data.data.id;

    const respCbN = await LovService.getCompanyByName(userCompany());
    company.value = respCbN.data.data[0];

    if (userInfo.value.leveltenant === 2) {
      const param = {
        db_instance: company.value.db_instance,
        org_id: company.value.value,
      };

      const checkAuth = await filterAuthByVendorname({
        info_id: userInfo.value.id,
        dbInstance: param.db_instance,
        value: param.org_id,
      });

      if (checkAuth.supplier === null) {
        router.push("/dashboard");
        return;
      }

      supplier.value = checkAuth.supplier;
      vendorId.value = checkAuth.supplier.vendor_id;
      vendorSiteId.value = checkAuth.supplier.vendor_site_id;
    }
  }
});

const userCompany = () => {
  const secretKey = "some-unique-key";
  const simpleCrypto = new SimpleCrypto(secretKey);
  return simpleCrypto.decrypt(sessionStorage.getItem("dropdownCompany"));
};

const onSelectFile = (event) => {
  file.value = event.files[0];
};

const onRemoveFile = (event) => {
  if (!event.files.length) {
    file.value = null;
  }
};

const getSupplier = (event) => {
  supplier.value = event.value;
  vendorId.value = event.value.vendor_id;
  vendorSiteId.value = event.value.vendor_site_id;
  term.value = null;
  billBank.value = null;
  paymentMethod.value = null;
  resetSelectedBL();
};

const getCompanySelect = (event) => {
  company.value = event.value;
  supplier.value = null;
  vendorId.value = null;
  vendorSiteId.value = null;
  term.value = null;
  billBank.value = null;
  paymentMethod.value = null;
  resetSelectedBL();
};

const getCostCenter = (event) => {
  costCenter.value = event.value;
  ccOwnerReload.value++;
  ccOwner.value = null;
};

const getDropdownCOA = async () => {
  if (!company.value || !costCenter.value) {
    getCOA.value = [];
    filteredCoa.value = [];
    return;
  }

  const result = await getListCoa(
    company.value.value,
    company.value.db_instance,
    costCenter.value.segment4
  );

  getCOA.value = result.data.data || [];
  filteredCoa.value = [...getCOA.value];

  selectedLines.value = selectedLines.value.map((line) => {
    const coaData = getCOA.value.find((coa) => coa.account === line.account);
    return {
      ...line,
      account: coaData?.account || line.account || null,
      coa_id: coaData?.code_combination_id || line.coa_id || null,
    };
  });
};

const searchAccount = (event) => {
  setTimeout(() => {
    if (!event.query.trim().length) {
      filteredCoa.value = [...getCOA.value];
    } else {
      filteredCoa.value = getCOA.value.filter((coa) => {
        return coa.account.toLowerCase().includes(event.query.toLowerCase());
      });
    }
  }, 250);
};

const onChangeCOALine = (event, index) => {
  let coaData = null;

  for (const coa of getCOA.value) {
    if (coa.code_combination_id == event.value.code_combination_id) {
      coaData = coa;
    }
  }

  if (coaData) {
    selectedLines.value[index].account = coaData.account;
    selectedLines.value[index].code_combination_id = coaData.code_combination_id;
    selectedLines.value[index].coa_id = coaData.code_combination_id;
  } else {
    toast.add({
      severity: "error",
      summary: "Data not Found",
      detail: "Data not Found",
      life: 3000,
    });
  }
};

const resetSelectedBL = () => {
  blNumber.value = null;
  selectedLines.value = [];
  getCOA.value = [];
  filteredCoa.value = [];
};

const activeSelectedLines = computed(() =>
  selectedLines.value.filter((line) => line.ACTIVE_FLAG === "Y" && line.isIncluded !== false)
);

const summary = computed(() => {
  const lines = activeSelectedLines.value;

  const totalLine =
    (lines.length && lines.reduce((accumulator, item) => accumulator + Number(item.amount || 0), 0)) ||
    0;

  const totalPpn =
    (lines.length &&
      lines
        .map((item) =>
          item.vat && item.vat.percentage_rate
            ? (item.vat.percentage_rate / 100) * Number(item.amount || 0)
            : 0
        )
        .reduce((prevValue, currValue) => prevValue + currValue, 0)) ||
    0;

  return {
    totalLine,
    totalPpn,
    totalInvoice: totalLine + totalPpn,
  };
});

const getDropdownVat = async () => {
  if (!invoiceDate.value || !company.value) {
    return;
  }

  const payload = {
    dbInstance: company.value.db_instance,
    param: "RATE",
    invoiceDate: invoiceDate.value,
  };

  const result = await getVATList(payload);
  getVAT.value = result.data;

  for (const line of selectedLines.value) {
    const isExistVat = getVAT.value.some((vat) => line.vat_code === vat.vat_code);
    if (!isExistVat) {
      line.vat_code = null;
      line.tax_rate_id = null;
      line.vat = null;
    }
  }

  getVAT.value.push({
    value: null,
    tax_rate_id: null,
    vat_code: "- No Select -",
    percentage_rate: null,
  });
};

const getDropdownWHT = async () => {
  if (!company.value) {
    return;
  }

  const result = await getWHTList(company.value.db_instance, company.value.value);
  getWHT.value = result.data;
  getWHT.value.push({
    value: null,
    wht_code_id: null,
    wht_code: "- No Select -",
  });
};

const onChangeVAT = (event, index) => {
  const currentLine = selectedLines.value[index];
  let vatData = null;

  for (const vat of getVAT.value) {
    if (vat.tax_rate_id == event.value) {
      vatData = vat;
    }
  }

  if (!vatData) {
    currentLine.vat_code = null;
    currentLine.tax_rate_id = null;
    currentLine.vat = null;
    return;
  }

  currentLine.percentage_rate = vatData.percentage_rate;
  currentLine.vat_code = vatData.vat_code;
  currentLine.tax_rate_id = vatData.tax_rate_id;
  currentLine.vat = vatData;
};

const onChangeWHT = (event, index) => {
  const currentLine = selectedLines.value[index];
  let whtData = null;

  for (const wht of getWHT.value) {
    if (wht.wht_code_id == event.value) {
      whtData = wht;
    }
  }

  if (!whtData) {
    currentLine.wht_code = null;
    currentLine.wht_code_id = null;
    return;
  }

  currentLine.wht_rate = whtData.wht_rate;
  currentLine.wht_code = whtData.wht_code;
  currentLine.wht_code_id = whtData.wht_code_id;
};

const toggleLineActive = (index) => {
  const currentLine = selectedLines.value[index];

  if (!currentLine || currentLine.ACTIVE_FLAG !== "Y") {
    return;
  }

  currentLine.isIncluded = currentLine.isIncluded === false;
};

const handleSelectBL = async (selectedDocument) => {
  displayBLModal.value = false;
  blNumber.value = selectedDocument.BL_NUMBER;
  selectedLines.value = [];

  const payload = {
    dbInstance: company.value.db_instance,
    vendorId: supplier.value.vendor_id,
    blNumber: selectedDocument.BL_NUMBER,
  };

  const response = await getBLTransactionDetails(payload);
  const lines = response.data.data || [];

  if (!lines.length) {
    toast.add({
      severity: "warn",
      summary: "Data not found",
      detail: "No B/L transaction detail was found",
      life: 3000,
    });
    return;
  }

  selectedLines.value = await Promise.all(
    lines.map(async (line) => {
      return {
        sourceId: line.ID,
        category: line.CATEGORY,
        siNumber: line.SI_NUMBER,
        description: line.CATEGORY || line.SI_NUMBER || line.BL_NUMBER,
        amount: Number(line.AMOUNT || 0),
        account: line.COA,
        coa_id: null,
        vat: null,
        vat_code: null,
        tax_rate_id: null,
        wht_code: null,
        wht_code_id: null,
        ACTIVE_FLAG: line.ACTIVE_FLAG || "Y",
        isIncluded: (line.ACTIVE_FLAG || "Y") === "Y",
      };
    })
  );

  await getDropdownCOA();
};

const handleChangeTax = (event) => {
  const { value } = event.target;
  taxInvoiceNo.value = value.replace(/[a-zA-Z]/g, "").substring(0, 20);
};

const formattingDate = (date, withTime) => {
  const theDate = new Date(date);
  const strDate =
    theDate.getFullYear() +
    "-" +
    (theDate.getMonth() + 1) +
    "-" +
    theDate.getDate();
  const strTime =
    theDate.getHours() +
    ":" +
    theDate.getMinutes() +
    ":" +
    theDate.getSeconds();

  if (withTime) {
    return `${strDate} ${strTime}`;
  }

  return `${strDate}`;
};

const validateSimilarInvoice = async (payload) => {
  try {
    const response = await checkSimilarInvoice(payload);
    const similarInvoice = response?.data?.data;

  if (!similarInvoice?.hasSimilarInvoice || !similarInvoice.similarInvoices?.length) {
    return true;
  }

    similarInvoices.value = similarInvoice.similarInvoices;
    similarInvoiceDialog.value = true;

    return await new Promise((resolve) => {
      similarInvoiceResolver.value = resolve;
    });
  } catch (error) {
    toast.add({
      severity: "error",
      summary: "Failed to validate similar invoice",
      life: 3000,
    });
    return false;
  }
};

const confirmSimilarInvoiceDialog = () => {
  similarInvoiceDialog.value = false;
  similarInvoices.value = [];
  const resolver = similarInvoiceResolver.value;
  similarInvoiceResolver.value = null;
  if (resolver) {
    resolver(true);
  }
};

const cancelSimilarInvoiceDialog = () => {
  similarInvoiceDialog.value = false;
  similarInvoices.value = [];
  const resolver = similarInvoiceResolver.value;
  similarInvoiceResolver.value = null;
  if (resolver) {
    resolver(false);
  }
};

const cancel = () => {
  router.push("/dashboard");
};

const save = async () => {
  const isFormValid = await v$.value.$validate();
  const activeLines = activeSelectedLines.value;

  if (!isFormValid || !activeLines.length) {
    toast.add({
      severity: "error",
      summary: "Please fill all required fields",
      life: 3000,
    });
    return;
  }

  const invalidCoaLine = activeLines.find((line) => !line.coa_id);
  if (invalidCoaLine) {
    toast.add({
      severity: "error",
      summary: "COA mapping not found",
      detail: `Unable to map COA for category ${invalidCoaLine.category || "-"}`,
      life: 3000,
    });
    return;
  }

  const payload = {
    header: {
      INVOICE_NO: invoiceNo.value,
      INVOICE_DATE: formattingDate(invoiceDate.value),
      REVISION_NUM: 0,
      TAX_NO: taxInvoiceNo.value,
      TAX_DATE: formattingDate(taxInvoiceDate.value),
      DESCRIPTION: description.value,
      CURRENCY_CODE: currency.value.currency_code,
      VENDOR_ID: vendorId.value,
      INVOICE_AMOUNT: summary.value.totalLine,
      TAX_AMOUNT: summary.value.totalPpn,
      TOTAL_AMOUNT: summary.value.totalInvoice,
      ORG_ID: parseInt(company.value.value),
      STATUS: invoiceStatus.value,
      CREATED_BY: userInfo.value.id,
      CREATION_DATE: formattingDate(new Date(), true),
      LAST_UPDATE_DATE: formattingDate(new Date(), true),
      LAST_UPDATED_BY: userInfo.value.id,
      PAYMENT_METHOD_LOOKUP_CODE: paymentMethod.value.payment_method,
      GL_DATE: formattingDate(glDate.value),
      TERMS_ID: term.value.term_id,
      ACCTS_CODE_COMBINATION_ID: null,
      EXTERNAL_BANK_ACCOUNT_ID: billBank.value.ext_bank_account_id,
      INVOICE_TYPE: "INVOICE PROXY",
      CATEGORY_ID: null,
      MAPING_ID: null,
      REFERENCE_NUMBER: blNumber.value,
      BL_NUMBER: blNumber.value,
      VENDOR_SITE_ID: vendorSiteId.value,
      COST_CENTER: costCenter.value.segment4,
      DB_INSTANCE: company.value.db_instance,
      CC_OWNER: ccOwner.value ? ccOwner.value.USER_EMAIL : null,
    },
    dataLines: [],
    dataReimburstments: [],
  };

  activeLines.forEach((item, index) => {
    payload.dataLines.push({
      LINE_NUM: index + 1,
      ITEM_DESCRIPTION: item.category || item.description,
      CATEGORY_NAME: item.category || null,
      AMOUNT: item.amount,
      ORGANIZATION_ID: company.value.value,
      CREATED_BY: userInfo.value.id,
      CREATION_DATE: formattingDate(new Date(), true),
      LAST_UPDATE_DATE: formattingDate(new Date(), true),
      LAST_UPDATED_BY: userInfo.value.id,
      CURRENCY_CODE: currency.value.currency_code,
      REVISION_NUM: 0,
      VENDOR_ID: vendorId.value,
      VENDOR_SITE_ID: vendorSiteId.value,
      CATEGORY_DETAIL_ID: 0,
      VAT_CODE: item.vat_code !== "- No Select -" ? item.vat_code : null,
      WHT_CODE: item.wht_code !== "- No Select -" ? item.wht_code : null,
      COA_ID: item.coa_id,
      VAT_CODE_ID: item.tax_rate_id,
      WHT_CODE_ID: item.wht_code_id,
      REMARKS: item.siNumber || null,
    });
  });

  const shouldContinue = await validateSimilarInvoice(payload);
  if (!shouldContinue) {
    return;
  }

  const formData = new FormData();
  formData.append("payload", JSON.stringify(payload));
  formData.append("file", file.value);

  try {
    progress.value = true;
    const res = await saveInvoice(formData);

    if (res.status === 201) {
      invoiceNo.value = res.data.data.invoice_no;
      file.value = null;
      fileUpload.value.clear();
      v$.value.$reset();
      disabledButton.value = true;
      progress.value = false;

      toast.add({
        severity: "success",
        summary: "Successfully save new invoice",
        life: 3000,
      });

      return;
    }

    progress.value = false;
  } catch (err) {
    progress.value = false;

    if (err.message.includes("Network Error")) {
      toast.add({
        severity: "error",
        summary: "Network Error",
        detail: "Connection Down. Please check your invoice status on the list menu.",
      });
      return;
    }

    if (err.response?.status === 400 || err.response?.status === 403) {
      if (err.response.data.message.includes("exist")) {
        errorExisting.value = true;
      }

      toast.add({
        severity: "error",
        summary: err.response.data.message,
        life: 3000,
      });
      return;
    }

    toast.add({
      severity: "error",
      summary: "Server Error: Unsuccessfully save new invoice",
      life: 3000,
    });
  }
};
</script>
